export enum AppSymbols {
  point = '·',
  dash = '–',
}
